import React from 'react';
import { Button, Dropdown, FormCheck as Checkbox, Row, Col } from 'react-bootstrap';
import { ColumnDescription } from 'react-bootstrap-table-next';
import { FaHistory, FaBars, FaFilter } from 'react-icons/fa/index';
//import { MultiselectProps, Multiselect } from 'react-bootstrap-multiselect-ts';
//import Multiselect from 'react-multi-select-component';

import filterFactory, { numberFilter, multiSelectFilter, Comparator } from 'react-bootstrap-table2-filter';

//import { User } from '../lib/dataAccess/DataAccess'
import Navigation from '../components/navigation/Navigation';
import Table from '../components/Table';
import Modal from '../components/Modal';
import Drawer from '../components/Drawer';
import { Updating, Success, Error, ErrorMessage } from '../components/visuals/Visuals'
import ForecastHistory from '../components/forecast/ForecastHistory';
import ValidatedInput from '../components/input/ValidatedInput';
import Multiselect from '../components/Multiselect';

import { Prognosis, tryParseInt, UserDataForecastId } from '../lib/utilities';
import { Forecast, General, User } from '../lib/dataAccess/DataAccess';
import { IForecast, IForecastView, IUserData, IGroup, IForecastOverview } from '../lib/types/types';

interface Props {
    role: String
};
interface State {
    error: String | null,
    isLoading: boolean,
    isFilterOptionsLoading: boolean,
    data: ExtendedForecastOverview[],
    lastSaved: Date | null,
    showHistoryModal: boolean,
    showSaveFilterModal: boolean,
    showDeleteFilterModal: boolean,
    selectedForecastIndex: number,
    selectedForecastId: number,
    showFilterMenu: boolean,

    selectedViewIndex: number,
    activeView: IForecastView,
    userData: IUserData[],

    //HATE THIS PROJECT, the code need major refactoring but no time. ps. dont use bootstrap table again....
    searchText: string,

    /* Options to filter with */
    filterOptions: {
        students: { label: string, value: number }[],
        courses: { label: string, value: string }[],
        classes: { label: string, value: number }[],
        teachers: { label: string, value: string }[],
        units: { label: string, value: number }[],
        schools: { label: string, value: number }[],
        groups: { label: string, value: number }[],
        prognoses: { label: string, value: number }[],
        SSNs: { label: string, value: number }[]
    },
    /* Filters */
    studentFilter?: any
    courseFilter?: any
    classFilter?: any
    teacherFilter?: any
    unitFilter?: any
    schoolFilter?: any
    groupFilter?: any
    prognosisFilter?: any
    SSNFilter?: any
};

enum UpdateFlag {
    Idle,
    Updating,
    Success,
    Error
}

interface ExtendedForecastOverview extends IForecastOverview {
    internalIndex: number,
    updating: UpdateFlag,
    studentName: string,
    /* Filterfields */
    //studentId: number,
    class: string,
    SSNNum: number,
    schoolName: string,
    teacherNames: string,
    teacherExternalIds: string
    //schoolId: number
}

//"hideable"(???)
const hidableColumns: { value: string, name: string }[] = [ 
    { value: 'unitName', name: 'Enhet' }, 
    { value: 'schoolName', name: 'Skola'} , 
    { value: 'class', name: 'Klass' }, 
    { value: 'courseName', name: 'Kurser/Ämnen' }, 
    { value: 'history', name: 'Historik' },
    { value: 'group', name: 'Grupp' },
    { value: 'studentSSN', name: 'Personnummer' },
    { value: 'teacher', name: 'Lärare'}
];
const defaultColumnValues = {
    [hidableColumns[0].value]: false,
    [hidableColumns[1].value]: true,
    [hidableColumns[2].value]: true,
    [hidableColumns[3].value]: true,
    [hidableColumns[4].value]: true,
    [hidableColumns[5].value]: false,
    [hidableColumns[6].value]: false,
    [hidableColumns[7].value]: false
}
const emptyFilters = {
    schools: [],
    units: [],
    classes: [],
    teachers: [],
    courses: [],
    students: [],
    groups: [],
    prognoses: [],
    SSNs: []
}
const emptySelectedOptions = {
    students: [],
    courses: [],
    classes: [],
    teachers: [],
    units: [],
    schools: [],
    groups: [],
    prognoses: [],
    SSNs: []
}

const searchableColumns = [
    { dataField:'unitName', activeField: 'unitName' }, 
    { dataField:'schoolUnitName', activeField: 'schoolName' },
    { dataField:'className', activeField: 'class' },
    { dataField:'courseDisplayName', activeField: 'courseName' },
    { dataField:'studentName', active: true },
    { dataField:'studentSSN', activeField: 'studentSSN' },
    { dataField:'groupName', activeField: 'group' },
    { dataField:'teacherNames', activeField: 'teacher' }
]

export default class ForecastInputPage extends React.Component<Props, State>
{   
    constructor(props: Props) 
    {
        super(props);

        this.getDataAsync = this.getDataAsync.bind(this);
        this.getFilterData = this.getFilterData.bind(this);

        this.updatePrognosis = this.updatePrognosis.bind(this);
        this.setColumnVisability = this.setColumnVisability.bind(this);
        this.rollbackHistoricPrognosis = this.rollbackHistoricPrognosis.bind(this);

        this.setSelectedFilter = this.setSelectedFilter.bind(this);
        this.updateView = this.updateView.bind(this);
        this.clearView = this.clearView.bind(this);
        this.setView = this.setView.bind(this);

        this.saveFilterView = this.saveFilterView.bind(this);
        this.deleteSelectedView = this.deleteSelectedView.bind(this);

        this.state = {
            isLoading: true,
            isFilterOptionsLoading: true,
            data: [],
            error: null,
            showHistoryModal: false,
            showSaveFilterModal: false,
            showDeleteFilterModal: false,
            selectedForecastIndex: -1,
            selectedForecastId: -1,
            lastSaved: null,
            showFilterMenu: false,
            searchText: "",
            filterOptions: {
                students: [],
                courses: [],
                classes: [],
                teachers: [],
                units: [],
                schools: [],
                groups: [],
                prognoses: [],
                SSNs: []
            },
            activeView: {
                filters: emptyFilters,
                columns: defaultColumnValues,
                selectedOptions: emptySelectedOptions
            },
            selectedViewIndex: -1,
            userData: []
        }
    }

    componentDidMount() {
        this.getDataAsync();
        this.getFilterData();
    }

    async getFilterData() {
        try {
            let studentsPromise = General.getStudents();
            let coursesPromise = General.getCourses();
            let classesPromise = General.getClasses();
            let teachersPromise = General.getTeachers();
            let unitsPromise = General.getUnits();
            let schoolsPromise = General.getSchools();
            let groupPromise = General.getGroups();

            let userDataPromise = User.getUserData(UserDataForecastId);
    
            const students = await studentsPromise;
            const courses = await coursesPromise;
            const classes = await classesPromise;
            const teachers = await teachersPromise;
            const units = await unitsPromise;
            const schools = await schoolsPromise;
            const groups = await groupPromise;
            const prognoses = Prognosis.defaultOptions;

            const userData = await userDataPromise;
            
            const courseObject = courses.reduce((acc: any, course) => {
                    acc[course.name] = course;
                    return acc;
                }, {});
            const uniqueCourses = Object.keys(courseObject).map(key => courseObject[key]);

            let uData = userData.filter(e => e.name == 'forecast-filter')
                            .map(uD => ({ 
                                id: uD.id,
                                name: uD.name,
                                data: {
                                    name: uD.data.name,
                                    data: {
                                        columns: {
                                            ...defaultColumnValues,
                                            ...uD.data.data.columns
                                        },
                                        filters: {
                                            ...emptyFilters,
                                            ...uD.data.data.filters
                                        },
                                        selectedOptions: {
                                            ...emptySelectedOptions,
                                            ...uD.data.data.selectedOptions
                                        }
                                    }
                                }
                            }));

            this.setState({
                isFilterOptionsLoading: false, 
                filterOptions: {
                    students: students.map(s => ({label: `${s.firstName} ${s.lastName}`, value: s.id})), 
                    courses: uniqueCourses.map(c => ({label: `${c.displayName}, ${c.name}`, value: c.name})), 
                    classes: classes.map(c => ({label: [...[c.name], ...(c.school ? [c.school.name] : [])].join(", "), value: c.id, extra: c.name})), 
                    teachers: teachers.map(t => ({label: `${t.fullname}, ${t.externalId}`, value: t.externalId})),
                    units: units.map(u => ({label: u.name, value: u.id})), 
                    schools: schools.map(s => ({label: s.name, value: s.id})),
                    groups: groups.map(g => ({label: g.name, value: g.id})),
                    prognoses: prognoses.map(p => ({label: p.value, value: p.key})),
                    SSNs: students.map(s => ({label: s.socialSecurityNumber, value: tryParseInt(s.socialSecurityNumber.replace(/\D/g, ''), -1)})).filter(({label, value}) => value > 0)
                },
                userData: uData
            });
        }
        catch (error) {
            this.setState({error: error.message});
        }
    }

    async getDataAsync() {

        const forecastPromise = Forecast.getForecastOverviews();
        let teachersPromise = General.getTeachers();

        let view = this.state.activeView;
        const activeViewId = sessionStorage.getItem("activeViewId");
        
        if(activeViewId != null) {
            const dataId = parseInt(activeViewId);
            //userView = await getUserData(dataId);
            //view = { ...userView, columns: { ...defaultColumnValues, ...userView.columns }}
        }

        const forecasts = await forecastPromise;
        const teachers = await teachersPromise;

        //console.log({top100Forecasts: forecasts.slice(0, 100)});

        let teacherLookup: { [id:number]: { id: number, fullname: string, externalId: string } } = {};

        teachers.forEach(t => {
            teacherLookup[t.id] = t;
        })
        
        //Maps students to internal structure containing index and renderingflag for update
        const data = forecasts
            .filter((f: IForecastOverview) => f != null)
            .sort((a: IForecastOverview, b: IForecastOverview) => 
                // @ts-ignore: Object is possibly 'null'
                a.courseDisplayName == b.courseDisplayName ? (a.studentLastName > b.studentLastName ? 1 : -1) : (a.courseDisplayName > b.courseDisplayName ? 1 : -1)
            ).map((forecast, index): ExtendedForecastOverview => { 
                const teacherIds: number[] = 
                                (forecast.teachers || '')
                                    .split(',')
                                    .map(id => tryParseInt(id, -1))
                                    .filter(e => e != -1)
                                    .reduce((acc: number[], e: number) => (acc.indexOf(e) > -1 ? acc : [...acc, e]), []);
                                    
                let teacherNames: string[] = [];
                let teacherExternalIds: string[] = [];

                teacherIds.forEach(id => {
                    if(teacherLookup[id]) {
                        teacherNames.push(teacherLookup[id].fullname);
                        teacherExternalIds.push(teacherLookup[id].externalId);
                    }
            });

            return { ...forecast, ...{
                    internalIndex: index, 
                    updating: UpdateFlag.Idle,
                    studentName: `${forecast.studentLastName}, ${forecast.studentFirstName}`,
                    //teacherName: "",//forecast.teachingTeacher !== null ? forecast.teachingTeacher.map(teacher => teacher.fullname).join(", ") : "",
                    class: forecast.className,
                    studentPrognosis: forecast.studentPrognosis || 5,
                    SSNNum: tryParseInt(forecast?.studentSSN?.replace(/\D/g, '') || '', -1),
                    schoolName: forecast.schoolUnitName,
                    teacherNames: teacherNames.join(', '),
                    teacherExternalIds: teacherExternalIds.join(';')
                    /* Filterfields, TODO: should these fields even be able to be null? */
                    /*studentId: forecast.student !== null ? forecast.student.id : -1,
                    courseId: forecast.course !== null ? forecast.course.id : -1,
                    //classId: forecast.class !== null ? forecast.class.id : -1,
                    unitId: forecast.unit !== null ? forecast.unit.id : -1,
                    schoolId: forecast.school !== null ? forecast.school.id : -1,
                    groupId: forecast.group !== null ? forecast.group.id : -1*/
                }}; 
        });

        this.setState({ data: data, isLoading: false, activeView: view });
    }

    async updatePrognosis(_index: number, id: number, prognosis: number) {
        const index = this.state.data.findIndex((e) => e.internalIndex == _index);

        const data = this.state.data[index];

        if (data.studentPrognosis !== prognosis || data.updating === UpdateFlag.Error) {
            //SetState below sets the prognosis and updateflag of the row.
            this.setState(({data}) => ({
                data: [
                    ...data.slice(0, index),
                    {
                        ...data[index],
                        prognosis: prognosis,
                        studentPrognosis: prognosis,
                        updating: UpdateFlag.Updating
                    },
                    ...data.slice(index + 1)
                ]
            }));
    
            try {
                const success = await Forecast.setForecastPrognosis(id, prognosis);

                //Setting the statusflag to 'Success'
                this.setState(({data}) => ({ data: [ ...data.slice(0, index), { ...data[index], updating: UpdateFlag.Success }, ...data.slice(index + 1) ] }),
                    //Callback that sets the updateFlag to Idle, else we get rendering issues when we sort the list
                    () => setTimeout(() => { 
                        this.setState(({data}) => ({ data: [ ...data.slice(0, index), { ...data[index], updating: UpdateFlag.Idle }, ...data.slice(index + 1) ] }));
                    }, 10000)
                );
            }
            catch (error) {
                console.error(error);

                //Setting the statusflag to 'Error'
                this.setState(({data}) => ({ error: error, data: [ ...data.slice(0, index), { ...data[index], updating: UpdateFlag.Error }, ...data.slice(index + 1) ] }));
            }

        } else { /*console.log('prognosis identical...');*/ }
    }

    async rollbackHistoricPrognosis(prognosis: number) {
        const index = this.state.data.findIndex((e) => e.internalIndex == this.state.selectedForecastIndex);
        const forecastId = this.state.data[index].forecastId;
        await this.updatePrognosis(this.state.selectedForecastIndex, forecastId, prognosis);
        this.setState({showHistoryModal: false});
    }

    getColor(prognosis: number) {
        switch (prognosis) {
            case 1: {
                return 'bg-light-red';
            }
            case 2: {
                return 'bg-yellow';
            }
            case 3: {
                return 'bg-light-green';
            }
            case 4: {
                return 'bg-green';
            }
            case 5: {
                return 'bg-blue';
            }
            default: {
                return '';
            }
        }
    }

    getUpdateIcon(updateFlag: UpdateFlag) {
        switch (updateFlag) {
            case UpdateFlag.Idle: {
                return null;
            }
            case UpdateFlag.Error: {
                return <Error errorMessage={"Fel vid sparning"} />;
            }
            case UpdateFlag.Success: {
                return <Success />;
            }
            case UpdateFlag.Updating: {
                return <Updating />;
            }
        }
    }

    setColumnVisability(key: string) {
        this.setState(({activeView}) => ({ 
            activeView: { 
                ...activeView, 
                columns: { 
                    ...activeView.columns, 
                    [key]: !activeView.columns[key]
                } 
            } 
        }));
    }

    setSelectedFilter(selected: {label:string, value: number | string, extra?: string}[], key: string) {
        const keyFilter = (key: string) => {
            //Remake as object instead?
            switch (key) {
                case 'students': return this.state.studentFilter;
                case 'courses': return this.state.courseFilter;
                case 'classes': return this.state.classFilter;
                case 'teachers': return this.state.teacherFilter;
                case 'units': return this.state.unitFilter;
                case 'schools': return this.state.schoolFilter;
                case 'groups': return this.state.groupFilter;
                case 'prognoses': return this.state.prognosisFilter;;
                case 'SSNs': return this.state.SSNFilter;
            }
        }

        const ids = key == 'classes' ? 
                        selected.map(e => e.value).filter(e => e != undefined)
                    : selected.map(e => e.value);

        this.setState(({activeView}) => ({
            activeView: {
                ...activeView,
                filters: {
                    ...activeView.filters,
                    [key]: ids
                },
                selectedOptions: {
                    ...activeView.selectedOptions,
                    [key]: selected
                }
            }
        }), keyFilter(key)(ids));
    }

    updateView(index: number) {
        const filterData = this.state.userData[index].data.data as IForecastView;

        this.setView(filterData, index);
    }

    clearView() {
        const emptyView = {
            filters: { schools: [], units: [], classes: [], teachers: [], courses: [], students: [], groups: [], prognoses: [], SSNs: [] },
            columns: defaultColumnValues,
            selectedOptions: { students: [], courses: [], classes: [], teachers: [], units: [], schools: [], groups: [], prognoses: [], SSNs: [] }
        }
        this.setView(emptyView, -1);
    }

    setView(view: IForecastView, index: number) {

        //Creates this object incase something is off in the db-data
        const newView = {
            ...{
                filters: {
                    schools: [],
                    units: [],
                    classes: [],
                    courses: [],
                    students: [],
                    groups: [],
                    prognoses: [],
                    SSNs: []
                },
                columns: defaultColumnValues,
                selectedOptions: {
                    students: [],
                    courses: [],
                    classes: [],
                    units: [],
                    schools: [],
                    groups: [],
                    prognoses: [],
                    SSNs: []
                }
            }, ...view
        };

        this.setState(
            {activeView: newView, selectedViewIndex: index},
            () => {
                this.state.studentFilter(newView.filters.students);
                this.state.courseFilter(newView.filters.courses);
                this.state.classFilter(newView.filters.classes);
                this.state.teacherFilter(newView.filters.teachers);
                this.state.unitFilter(newView.filters.units);
                this.state.schoolFilter(newView.filters.schools);
        });
    }

    async saveFilterView() {
        try {
            const index = this.state.selectedViewIndex;

            if(index > -1) {
                const name = this.state.userData[index].data.name;

                const response = await User.upsertUserData({ 
                    ...this.state.userData[index], data: { name, data: this.state.activeView }
                });

                //TODO: Använd respons för att sätta om värden i state.userData utifall namn har ändrats

                this.setState(({userData}) => ({
                    showSaveFilterModal: false, 
                    showFilterMenu: false, 
                    userData: [...userData.slice(0, index), response, ...userData.slice(index + 1)]
                }));
            }
            else {
                const input = document.getElementById("forecast-input-save-new-view-name") as HTMLInputElement;
                const name = input != null ? input.value : '';

                const data = {id: -1, name: 'forecast-filter', data: { name, data: this.state.activeView } };
                
                //TODO: Kontrollera att nya namnet inte är lika med de tidigare

                const response = await User.upsertUserData(data);

                this.setState(({userData}) => ({
                    showSaveFilterModal: false, showFilterMenu: false,
                    userData: [ ...userData, response ],
                    selectedViewIndex: userData.length
                }));
            }
        }
        catch(error) {
            console.error(error);
            this.setState({error, showSaveFilterModal: false, showFilterMenu: false})
        }
    }

    async deleteSelectedView() {
        try {
            const dataId = this.state.userData[this.state.selectedViewIndex].id;
            const success = await User.removeUserData(dataId);
    
            const emptyView = {
                filters: { schools: [], units: [], classes: [], teachers: [], courses: [], students: [], groups: [], prognoses: [], SSNs: [] },
                columns: defaultColumnValues,
                selectedOptions: { students: [], courses: [], classes: [], teachers: [], units: [], schools: [], groups: [], prognoses: [], SSNs: [] }
            }

            this.setState(({userData, selectedViewIndex}) =>
                ({ 
                    activeView: emptyView, selectedViewIndex: -1, 
                    showDeleteFilterModal: false, showFilterMenu: false,
                    userData: [
                        ...userData.slice(0, selectedViewIndex),
                        ...userData.slice(selectedViewIndex + 1)
                    ]
                }),
                () => {
                    this.state.studentFilter(emptyView.filters.students);
                    this.state.courseFilter(emptyView.filters.courses);
                    this.state.classFilter(emptyView.filters.classes);
                    this.state.teacherFilter(emptyView.filters.teachers);
                    this.state.unitFilter(emptyView.filters.units);
                    this.state.schoolFilter(emptyView.filters.schools);
                    this.state.groupFilter(emptyView.filters.groups);
                    this.state.prognosisFilter(emptyView.filters.prognoses);
                    this.state.SSNFilter(emptyView.filters.SSNs);
            });
        }
        catch(error) {
            console.error(error);
            this.setState({error, showDeleteFilterModal: false, showFilterMenu: false})
        }
    }

    searchFilterData(data: any[], searchFilter: string, searchableColumns: string[]) {

        const searchString = searchFilter.toLocaleLowerCase();
        const result = data.filter((row: any) => {
            let valid = false;
            for (let i = 0; i < searchableColumns.length; i++) {
                valid = row[searchableColumns[i]]?.toString()?.toLowerCase()?.indexOf(searchString) > -1;
                if (valid) break;
            }
            return valid;
          });

        return result;
    }

    render() {
        const { error, isLoading, isFilterOptionsLoading, data, searchText, 
                showHistoryModal, selectedForecastIndex, selectedForecastId, showFilterMenu, 
                activeView, filterOptions, showSaveFilterModal, showDeleteFilterModal,
            } = this.state;

        // selectedForecastId = selectedForecastIndex != -1 ? data[selectedForecastIndex].forecastId : -1;
        const selectedForecast = selectedForecastIndex != -1 ? data[selectedForecastIndex] : undefined;

        const selectedViewName = this.state.selectedViewIndex != -1 ? this.state.userData[this.state.selectedViewIndex].data.name : '';

        const filterColumns : ColumnDescription<any, any>[] = [
            /* Filtercolumns */
            {   //StudentFilterColumn
                dataField: 'studentId',
                text: 'StudentFilter',
                //hidden: true,
                headerStyle: { width: '1px', display: 'none'},
                style: { width: 0, display: 'none'},
                searchable: false,
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        this.setState({studentFilter: filter});
                    },
                    comparator: Comparator.EQ,
                    style: { width:'0px', visibility: 'hidden' }
                })
            },
            {   //CourseFilterColumn
                dataField: 'courseName',
                text: 'CourseFilter',
                //hidden: true,
                headerStyle: { width: '1px', display: 'none'},
                style: { width: '1px', display: 'none'},
                searchable: false,
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        this.setState({courseFilter: filter});
                    },
                    comparator: Comparator.EQ,
                    style: {width:'0px'}
                })
            },
            {   //ClassFilterColumn
                dataField: 'classId',
                text: 'ClassFilter',
                //hidden: true,
                headerStyle: { width: 0, display: 'none'},
                style: { width: 0, display: 'none'},
                searchable: false,
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        this.setState({classFilter: filter});
                    },
                    comparator: Comparator.EQ,
                    style: {width:'0px'}
                })
            },
            {   //TeacherFilterColumn
                dataField: 'teacherExternalIds',
                text: 'TeacherFilter',
                //hidden: true,
                headerStyle: { width: 0, display: 'none'},
                style: { width: 0, display: 'none'},
                searchable: false,
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        this.setState({teacherFilter: filter});
                    },
                    comparator: Comparator.LIKE,
                    style: {width:'0px'}
                })
            },
            {   //UnitFilterColumn
                dataField: 'unitId',
                text: 'UnitFilter',
                //hidden: true,
                headerStyle: { width: 0, display: 'none'},
                style: { width: 0, display: 'none'},
                searchable: false,
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        this.setState({unitFilter: filter});
                    },
                    comparator: Comparator.EQ,
                    style: {width:'0px'}
                })
            },
            {   //SchoolFilterColumn
                dataField: 'schoolUnitId',
                text: 'SchoolFilter',
                //hidden: true,
                headerStyle: { display: 'none'},
                style: { display: 'none'},
                searchable: false,
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        //schoolFilter = filter;
                        this.setState({schoolFilter: filter});
                    },
                    comparator: Comparator.EQ,
                    style: {width:'0px'}
                })
            },
            {   //GroupFilterColumn
                dataField: 'groupId',
                text: 'GroupFilter',
                //hidden: true,
                headerStyle: { display: 'none'},
                style: { display: 'none'},
                searchable: false,
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        //groupFilter = filter;
                        this.setState({groupFilter: filter});
                    },
                    comparator: Comparator.EQ,
                    style: {width:'0px'}
                })
            },
            {   //GroupFilterColumn
                dataField: 'SSNNum',
                text: 'SSNFilter',
                //hidden: true,
                headerStyle: { display: 'none'},
                style: { display: 'none'},
                searchable: false,
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        //groupFilter = filter;
                        this.setState({SSNFilter: filter});
                    },
                    comparator: Comparator.EQ,
                    style: {width:'0px'}
                })
            }
        ];

        const columns : ColumnDescription<any, any>[] = [
            {
                dataField: 'forecastId',
                text: 'ID',
                hidden: true,
                searchable: false
            }, {
                dataField: 'unitName',
                text: 'Enhet',
                sort: true,
                hidden: !activeView.columns['unitName'],
                searchable: activeView.columns['unitName']
            }, {
                dataField: 'schoolUnitName',
                text: 'Skola',
                style: { wordBreak: 'break-word' },
                sort: true,
                hidden: !activeView.columns['schoolName'],
                searchable: activeView.columns['schoolName']
            }, {
                dataField: 'className',
                text: 'Klass',
                sort: true,
                hidden: !activeView.columns['class'],
                searchable: activeView.columns['class']
            }, {
                dataField: 'courseDisplayName',
                text: 'Kurs/Ämne',
                sort: true,
                headerStyle: { wordBreak: 'break-word' },
                style: { wordBreak: 'break-word' },
                hidden: !activeView.columns['courseName'],
                searchable: activeView.columns['courseName']
            }, {
                dataField: 'studentName',
                text: 'Elev',
                style: { wordBreak: 'break-word' },
                sort: true
            }, {
                dataField: 'groupName',
                text: 'Grupp',
                style: { wordBreak: 'break-word' },
                hidden: !activeView.columns['group'],
                searchable: activeView.columns['group'],
                sort: true
            }, {
                dataField: 'teacherNames',
                text: 'Lärare',
                style: { wordBreak: 'break-word' },
                hidden: !activeView.columns['teacher'],
                searchable: activeView.columns['teacher'],
                sort: true
            }, {
                dataField: 'studentSSN',
                text: 'Personnummer',
                style: { textAlign: 'center' },
                hidden: !activeView.columns['studentSSN'],
                searchable: activeView.columns['studentSSN']
            }, {
                dataField: 'studentPrognosis',
                text: 'Prognos',
                headerStyle: { width: '17rem' },
                style: { padding: '0.5rem' },
                formatter: (cell: any, row: ExtendedForecastOverview) => {
                    const title = row.writableType === "permission-denied" ? 
                                    "Saknar skrivrättigheter"
                                  : row.writableType === "out-of-date" ?
                                    "Avslutat kurs"
                                  : "";

                    return (<div  className="form-group" style={{ marginBottom: 0, position: 'relative' }}>
                        <select disabled={!row.writable} 
                                className={`form-control ${row.writable ? '' : 'prognosis-disabled'} ${this.getColor(cell || 5)}`} 
                                value={cell || 5} onChange={(e) => this.updatePrognosis(row.internalIndex, row.forecastId, parseInt(e.target.value))}
                                title={title}
                        >
                            { Prognosis.options(!(row?.studentProgram?.startsWith("GR") || false))
                                .map(elem => 
                                    <option value={elem.key}>{elem.value}</option>
                            )}
                        </select>
                    </div>)
                },
                filter: multiSelectFilter({
                    options: {},
                    getFilter: (filter) => {
                        this.setState({prognosisFilter: filter});
                    },
                    comparator: Comparator.EQ,
                    style: {width:'0px', display:'none'}
                }),
                searchable: false
            }, {
                dataField: 'history',
                isDummyField: true,
                text: 'Historik',
                headerStyle: { width: '6rem', textAlign: 'center' },
                formatter: (_, row: ExtendedForecastOverview) => {
                    return (<div 
                        style={{ position: 'relative', textAlign: 'center', cursor: 'pointer', verticalAlign: 'middle' }} 
                        onClick={() => this.setState({showHistoryModal: true, selectedForecastIndex: row.internalIndex, selectedForecastId: row.forecastId}, () => { 
                            //console.log({row});
                        })}
                    >
                        {<FaHistory size={20} />}
                        <div style={{ position: 'absolute', right: '-2.5rem', top: '0.25rem' }}>
                            {this.getUpdateIcon(row.updating)}
                        </div>
                    </div>)
                },
                hidden: !activeView.columns['history'],
                searchable: false
            },
            ...filterColumns
        ];

        const mobileColumns : ColumnDescription<any, any>[] = [
            {
                dataField: 'forecastId',
                text: 'ID',
                hidden: true,
                searchable: false
            }, {
                dataField: 'studentName',
                text: 'Elev',
                style: { wordBreak: 'break-word' },
                sort: true
            }, 
            ...filterColumns
        ];

        const menuField = [
                (<div className="forecast-filter" title="Redigera filter" onClick={() => this.setState({showFilterMenu: true})}>
                    <div style={{height:'2.65rem', padding: '0 1rem'}}>
                        <FaFilter />
                    </div>
                </div>),
                (<div className="forecast-filter">
                    <Dropdown>
                        <Dropdown.Toggle id="forecast-view-dropdown">
                            { this.state.selectedViewIndex > -1 ?
                                this.state.userData[this.state.selectedViewIndex].data.name    
                            : "Välj filter" } &nbsp;
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={this.clearView}>
                               {"Återställ filter"}
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            {this.state.userData.map((d, index) => 
                                <Dropdown.Item onClick={()=>this.updateView(index)}>
                                    {d.data.name}
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>)
            ];

        const activeSearchColumns = searchableColumns
                .filter(({active, activeField}) => active || (activeField && activeView.columns[activeField]))
                .map(({dataField}) => dataField);

        const searchedData = this.searchFilterData(data, searchText, activeSearchColumns);

        return (
            <div className="render-forecastInputPage junit-page" style={{boxSizing: 'border-box'}}>
                <Navigation role={this.props.role} />
                <div className="junit-container" style={{ overflow: 'visible' }}>
                    <ErrorMessage hidden={error === null} style={{marginBottom:'1rem'}}>{error}</ErrorMessage>
                    <Modal show={showHistoryModal} title={"Prognoshistorik"}  onHide={() => this.setState({showHistoryModal: false})}>
                        <ForecastHistory forecastId={selectedForecastId} forecast={selectedForecast} setPrognosis={this.rollbackHistoricPrognosis} />
                    </Modal>
                    <Modal title={"Spara vy"} show={showSaveFilterModal} onHide={() => this.setState({showSaveFilterModal: false})}>
                        <div style={{marginBottom: '1rem'}}>
                            { this.state.selectedViewIndex > -1 ?
                                <span>{`Säker på att ni spara ändringarna till vyn '${selectedViewName}'?`}</span>
                            : <div style={{display:'flex'}}>
                                <span style={{fontSize: '1.25rem', marginTop: '0.25rem', marginRight: '0.5rem'}}>
                                    {'Spara filtervy som:'}
                                </span>
                                <ValidatedInput 
                                    style={{fontSize: '1.25rem', width: '25rem'}} 
                                    key="test" 
                                    id="forecast-input-save-new-view-name"
                                    errorMessage={"Felmeddellande"}
                                    validation={(value) => value != "fel"}
                                ></ValidatedInput>
                            </div> }
                        </div>
                        <Button style={{marginRight: '1rem'}} onClick={this.saveFilterView}>{"Spara"}</Button>
                        <Button onClick={() => this.setState({showSaveFilterModal: false})}>{"Avbryt"}</Button>
                    </Modal>
                    <Modal title={"Ta bort vy"} show={showDeleteFilterModal} onHide={() => this.setState({showDeleteFilterModal: false})}>
                        <div style={{marginBottom: '1rem'}}>
                            {`Säker på att du vill ta bort vyn '${selectedViewName}'?`}
                        </div>
                        <Button style={{marginRight: '1rem'}} onClick={this.deleteSelectedView}>{"Ja"}</Button>
                        <Button onClick={() => this.setState({showDeleteFilterModal: false})}>{"Nej"}</Button>
                    </Modal>
                    <Table 
                        keyField={ 'id' }
                        columns={ columns }
                        data={ searchedData }
                        loading={ isLoading }
                        menuField={ menuField }
                        pageOptions={{ pageStartIndex: 1,
                            paginationSize: 4,
                            sizePerPage: 30, 
                            sizePerPageList: [
                                { text: '15 prognoser', value: 15 },
                                { text: '30 prognoser', value: 30 },
                                { text: '50 prognoser', value: 50 },
                                { text: '100 prognoser', value: 100 }
                            ]}}
                        bsTableProps={{
                            filter: filterFactory(),
                            remote: { sort: true, search: true },
                            onTableChange: (type, newState) => {
                                if(type == "sort") {
                                    setTimeout(() => {
                                        const field = newState.sortField;
    
                                        const sortFunc = (a: any, b: any) => {
                                            return a[field] > b[field] ? 1 : a[field] == b[field] ? 0 : -1;
                                        }
    
                                        let sort = newState.sortOrder === "asc" ?
                                                        (a: any, b: any) => sortFunc(a, b)
                                                        : (a: any, b: any) => sortFunc(b, a)
        
                                        let result = data.sort((a, b) => sort(a, b));
                                        
                                        this.setState(() => ({data: result}));
                                    }, 0)
                                }
                                else if (type.toString() === "search") {
                                    let tmp: any = {...newState};
                                    const { searchText } = tmp;
                                    this.setState({ searchText })
                                }
                            },
                            rowStyle: (row: ExtendedForecastOverview, index: number) => {
                                switch (row.writableType) {
                                    case "out-of-date":
                                        return { backgroundColor: '#f1f1f1' };
                                    case "permission-denied": 
                                        return { backgroundColor: /*'#FEF5EC'*/'#d2d2d2' };
                                    default: return {};
                                }
                            },
                            rowClasses: "hover-darker"
                        }}
                    />
                    <Drawer show={showFilterMenu} onHide={() => this.setState({showFilterMenu: false})} title="Filterinställningar" style={{minWidth: '30%'}}>
                        <div className="forecast-filter-view" style={{padding: '0.5rem', marginBottom: '0.25rem'}}>
                            <Dropdown>
                                <Dropdown.Toggle id="forecast-view-dropdown">
                                    { this.state.selectedViewIndex > -1 ?
                                        this.state.userData[this.state.selectedViewIndex].data.name    
                                    : "Ny filtervy..." } &nbsp;
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={this.clearView}>
                                    {"Ny filtervy..."}
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    {this.state.userData.map((d, index) => 
                                        <Dropdown.Item onClick={()=>this.updateView(index)}>
                                            {d.data.name}
                                        </Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div style={{padding: '0.5rem 0.5rem', backgroundColor: '#E2E2E2', fontSize: '1.25rem'}}>
                            {"Visning av kolumner"}
                        </div>
                        <Row style={{padding:'0.5rem'}}>
                            {hidableColumns.map((c) => {
                                return (<Col xs={12} md={6}>
                                    <div style={{fontSize:'1.25rem', cursor: 'pointer'}} onClick={() => this.setColumnVisability(c.value)}>
                                        <Checkbox size={24} checked={activeView.columns[c.value]} style={{float:'left'}}/>
                                        <div>
                                            {c.name}
                                        </div>
                                    </div>
                                </Col>);
                            })}
                        </Row>
                        <div style={{padding: '0.5rem', backgroundColor: '#E2E2E2', fontSize: '1.25rem'}}>
                            {"Filter"}
                        </div>
                        <div style={{padding: '0.5rem'}}>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Elever:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.students}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'students')}
                                    options={filterOptions.students}
                                />
                            </div>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Kurser/Ämnen:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.courses}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'courses')}
                                    options={filterOptions.courses}
                                />
                            </div>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Klasser:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.classes}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'classes')}
                                    options={filterOptions.classes}
                                />
                            </div>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Lärare:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.teachers}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'teachers')}
                                    options={filterOptions.teachers}
                                />
                            </div>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Enheter:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.units}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'units')}
                                    options={filterOptions.units}
                                />
                            </div>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Skolor:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.schools}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'schools')}
                                    options={filterOptions.schools}
                                />
                            </div>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Grupper:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.groups}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'groups')}
                                    options={filterOptions.groups}
                                />
                            </div>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Personnummer:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.SSNs}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'SSNs')}
                                    options={filterOptions.SSNs}
                                />
                            </div>
                            <div style={{marginBottom:'1rem'}}>
                                <span style={{fontSize: '1.25rem', marginBottom: '0.25rem'}}>{"Prognos:"}</span>
                                <Multiselect
                                    value={activeView.selectedOptions.prognoses}
                                    onChange={(selected: any) => this.setSelectedFilter(selected, 'prognoses')}
                                    options={filterOptions.prognoses}
                                />
                            </div>
                            <br/>
                            { this.state.selectedViewIndex > -1 ? 
                                <div>       
                                    <Button style={{fontSize:'1.25rem'}} onClick={() => this.setState({showSaveFilterModal: true})}>
                                        Spara
                                    </Button>
                                    <Button style={{fontSize:'1.25rem', float:'right'}} variant="danger" onClick={()=> this.setState({showDeleteFilterModal: true})}>
                                        Ta bort
                                    </Button>
                                </div>
                              : <Button style={{fontSize:'1.25rem'}} onClick={() => this.setState({showSaveFilterModal: true})}>
                                      Spara som...
                                </Button>
                            }
                        </div>
                    </Drawer>
                </div>
            </div>
        );
    }
}
